<template>
  <div class="tab-pane fade show active" id="faq" role="tabpanel" aria-labelledby="faq-tab">
    <h2>FAQ</h2>
    <form v-on:submit.prevent="buscarPerguntasRespostas">
      <div class="d-flex align-items-center busca-ajuda">
        <input type="text" class="form-control flex-fill" id="busca-ajuda" placeholder="O que você procura?" v-model="pesquisa">
        <button type="submit" class="btn btn-secondary ml-3">Buscar</button>
      </div>
    </form>

    <template v-if="resultadoBusca === null">
      <template v-for="item in items">
        <h3 v-html="item.nome"></h3>
        <template v-for="questao in item.questoes">
          <h4 v-html="questao.titulo"></h4>
          <p v-html="questao.resposta"></p>
        </template>
      </template>
    </template>
    <template v-else>
      <p v-if="resultadoBusca.length" class="mt-4 text-right"><strong>{{ resultadoBusca.length }}</strong> resultados para "{{ termoPesquisado }}" <a href="javascript:void(0)" @click="limparBusca" class="small">Limpar busca</a></p>
      <p v-else class="mt-4 text-right"><strong>Nenhum</strong> resultado para "{{ termoPesquisado }}" <a href="javascript:void(0)" @click="limparBusca" class="small">Limpar busca</a></p>

      <hr/>

      <template v-for="itemBusca in resultadoBusca">
        <h4 v-html="itemBusca.titulo"></h4>
        <p><small class="form-text text-muted small" v-html="itemBusca.categoria"></small></p>
        <p v-html="itemBusca.resposta"></p>
      </template>

      <p v-if="resultadoBusca.length === 0">Tente pesquisa por outra palavra ou <a @click="$router.push('/contato')">fale conosco</a>.</p>
    </template>
  </div>
</template>

<script>
import Fuse from 'fuse.js'

export default {
  name: 'Faq',

  data () {
    return {
      pesquisa: '',
      termoPesquisado: '',
      fuse: null,
      items: [
        {
          nome: 'Sobre o Jaleko',
          questoes: [
            {
              titulo: 'O que é o Jaleko?',
              resposta: 'O Jaleko é uma empresa de desenvolvimento de soluções digitais, que visa unir educação e tecnologia a fim de melhorar a saúde no Brasil. Nossos esforços estão voltados a ajudar estudantes de medicina e empresas da área de saúde a crescer e contribuir com esse objetivo.'
            },
            {
              titulo: 'Como surgiu o Jaleko?',
              resposta: 'O Jaleko nasceu do sonho de dois alunos de Medicina no Rio de Janeiro, que acreditavam ser possível melhorar a saúde através da educação e da tecnologia. Logo após se formarem como médicos, ambos começaram a tornar esse sonho uma realidade, criando uma plataforma em que estudantes da área médica pudessem aprender com material alternativo, que "falasse sua língua".<br/>' +
                'Dessa forma, nasceu a primeira versão da plataforma Jaleko, com materiais de estudo para as provas da faculdade, conteúdos de prática médica e complementos específicos que não se aprendem na faculdade, como marketing, oratória, e finanças para médicos.'
            },
            {
              titulo: 'O que é a plataforma Jaleko?',
              resposta: 'Uma plataforma de estudo médico intuitiva e que dispõe de funcionalidades personalizadas. Após fazer o login, o acesso aos cursos e suas videoaulas, questões, resumos, mapas mentais, simulados é imediato. Os conteúdos estão organizados por categorias e disciplinas (ou sistemas) e há um mecanismo de busca que permite o usuário encontrar temas mais específicos e filtrá-los pelo tipo de material desejado.'
            },
            {
              titulo: 'Como são os conteúdos do Jaleko?',
              resposta: 'Os materiais são preparados e revisados por uma equipe de especialistas, que trabalham não apenas com base nas ementas dos principais cursos do país, mas também no feedback dos usuários e suas demandas por novidades.<br/>' +
                'Os professores passam por um processo de seleção e por treinamentos como de oratória, por exemplo, a fim de garantir que os conteúdos oferecidos prezem tanto pela qualidade técnica quanto didática.<br/>' +
                'Já os vídeos são pensados para serem curtos, com foco nos principais tópicos de cada tema, de forma a servir como um material de apoio aos estudos.'
            },
            {
              titulo: 'Quem faz parte do Jaleko?',
              resposta: 'Nosso time é formado por pessoas incríveis que querem melhorar a saúde do Brasil com você e, por isso, vão te dar todo suporte e material ao nosso alcance.'
            }
          ]
        },
        {
          nome: 'Perfil',
          questoes: [
            {
              titulo: 'Por que completar meu cadastro?',
              resposta: 'Para que sua experiência seja personalizada, algumas informações adicionais são necessárias. Se você ainda não complementou seus dados de perfil, pode fazer isso agora e nos ajudar a ajudá-lo. <a href="/perfil/meus-dados">Quero complementar meu perfil</a>.'
            },
            {
              titulo: 'Quais informações posso visualizar e/ou editar no meu perfil?',
              resposta: 'Acessando os "Meus Dados" no Perfil, você encontra as seguintes informações:<br/>' +
                '<strong>- Dados de acesso:</strong> visualize informações pessoais e redefina sua senha de acesso. Para alterar seu e-mail (login), entre em contato com um administrador de sua instituição.<br/>' +
                '<strong>- Dados pessoais:</strong> visualize e edite seu nome, data de nascimento, telefone e especialidade pretendida.<br/>' +
                '<strong>- Dados acadêmicos:</strong> aqui, a maioria dos seus dados são para visualização e estão associados à sua instituição de origem, mas você pode editar e atualizar as informações de "período atual", "semestre de início" e "previsão de formatura".'
            },
            {
              titulo: 'O que são os "Meus Cadernos"?',
              resposta: 'Nessa área, você tem acesso às anotações que criou em cada lição, com a possibilidade de buscar alguma nota específica.'
            }
            // {
            //   titulo: 'Como faço para alterar a minha foto de perfil?',
            //   resposta: 'Basta entrar no seu perfil e buscar no menu à esquerda a opção "inserir foto" ou "alterar foto".'
            // }
          ]
        },
        {
          nome: 'Cursos',
          questoes: [
            {
              titulo: 'Como estão organizados os cursos?',
              resposta: 'Os cursos estão organizados em seis grandes categorias e, dentro de cada uma, é possível visualizá-los por sistemas ou disciplinas:<br/>' +
                '<strong>- Ciclo Básico:</strong> matérias que normalmente fazem parte do currículo dos dois primeiros anos da faculdade, tais como Anatomia, Fisiologia, Embriologia e Bioquímica.<br/>' +
                '<strong>- Semiologia e Propedêutica:</strong> cursos relacionados às técnicas de exame do paciente, como Anamnese e Semiologia organizados por sistemas.<br/>' +
                '<strong>- Especialidades Clínicas e Cirúrgicas:</strong> dividimos as especialidades médicas em Clínicas e Cirúrgicas para facilitar os estudos. É nessa categoria que são encontrados cursos como Cardiologia, Pneumologia e Cirurgia Geral.<br/>' +
                '<strong>- Internato e Prática Médica:</strong> os últimos dois anos da faculdade têm um foco muito mais prático que teórico. Por esse motivo, reunimos nessa categoria os conteúdos mais voltados para prática, como os cursos de prescrição médica, plantão no CTI, abordagem das vias aéreas e ventilação mecânica.<br/>' +
                '<strong>- Além da Medicina:</strong> engloba temas que não fazem necessariamente parte do currículo formal, mas que podem ser de interesse dos estudantes e tornar-se um diferencial em sua formação, tais como Empreendedorismo, Finanças e Marketing, entre outros.'
            },
            {
              titulo: 'Como localizo um curso?',
              resposta: 'Através da barra de pesquisa ou navegando pelas categorias. Em cada uma é possível visualizar os tópicos organizados por sistemas ou por disciplina.'
            },
            {
              titulo: 'Como saber os temas abordados em um curso?',
              resposta: 'Na página do próprio curso é exibida uma lista com os temas abordados, divididos em módulos e lições.'
            },
            {
              titulo: 'O que é a "Sala de Aula"?',
              resposta: 'É o espaço onde os estão disponíveis os recursos de apoio e conteúdos de um curso como vídeos, questões, PDFs e referências, por exemplo. '
            },
            {
              titulo: 'Onde consigo dar feedbacks sobre os cursos?',
              resposta: 'No canto superior direito da sala de aula, você encontra a opção de avaliar a lição e deixar comentários. A sua opinião é essencial para o processo contínuo de melhoria dos conteúdos, produtos e processos. Você também pode entrar em contato conosco pela página <a href="/contato">Fale Conosco</a>.'
            },
            {
              titulo: 'Quais são os recursos disponíveis no player de vídeo?',
              resposta: 'O player de vídeo possui as seguintes funcionalidades:<br/>' +
                '<strong>- Volume:</strong> controle a intensidade do áudio no vídeo que está em visualização.<br/>' +
                '<strong>- Configuração:</strong> nesse botão você vai ter acesso a duas funcionalidades:<br/>' +
                '1) Qualidade: pode variar de 360p (menor qualidade) até 1080p (maior qualidade). O padrão é o modo automático, em que a qualidade vai variar de acordo com a sua internet e tamanho da tela do dispositivo.<br/>' +
                '2) Velocidade: você pode aumentar ou reduzir a reprodução. Caso esteja fazendo uma revisão rápida, por exemplo, pode aumentar em 1.5x ou 2.0x, ou diminuir, se quiser fazer notas enquanto o vídeo está sendo reproduzido.<br/>' +
                '<strong>- Tela cheia:</strong> clique nesse botão para assistir o vídeo em toda a tela.'
            },
            {
              titulo: 'Por que alguns tópicos de conteúdo são questões?',
              resposta: 'As questões estão destacadas como tópicos de conteúdo, tal como os vídeos, e têm como objetivo a fixação de conceitos apresentados nas videoaulas das lições. Quando respondidas, são apresentados o gabarito e um comentário, que reforçam conteúdos abordados previamente e o ajudam a entender que tópicos eventualmente precisam ser revisados. '
            },
            {
              titulo: 'O que são os PDFs disponíveis para download?',
              resposta: 'O material em PDF traz alguns aprofundamentos e informações adicionais para enriquecer seu conhecimento sobre os temas abordados nas videoaulas.'
            },
            {
              titulo: 'Como consigo acessar as anotações que fiz no "Meu Caderno"?',
              resposta: 'As notas sobre a sua lição podem ser visualizadas por meio do "Perfil", na opção "Meus Cadernos", ou retornando à lição na qual a anotação foi feita, por meio do menu de "Cursos" ou da busca.'
            },
            {
              titulo: 'Posso acessar as aulas pelo aplicativo do Jaleko?',
              resposta: 'Ainda não, mas estamos trabalhando nisso. Porém, você pode acessar a plataforma pelo computador, tablet ou celular utilizando um navegador web como o Safari ou Google Chrome.'
            }
          ]
        },
        {
          nome: 'Simulados',
          questoes: [
            {
              titulo: 'O que é a funcionalidade de "Simulados"?',
              resposta: 'É uma forma de testar seus conhecimentos sobre alguns temas através de perguntas e respostas. No modo treino é possível acessar aos gabaritos e comentários após responder às questões.'
            },
            {
              titulo: 'Como consigo localizar um simulado?',
              resposta: 'Clicando no item "Simulado", no cabeçalho da pltaforma, você acessa sua página personalizada de simulados e encontra a opção de acessar os "Simulados Jaleko".'
            }
          ]
        }
      ],
      conteudoBusca: [],
      resultadoBusca: null
    }
  },

  created () {
    if (this.$configEmpresa.textosConfiguraveis.textoFaq) {
      this.items = this.$configEmpresa.textosConfiguraveis.textoFaq
    }
  },

  mounted () {
    this.conteudoBusca = this.items.flatMap(item => {
      return item.questoes.map(q => {
        q.categoria = item.nome
        return q
      })
    })
    this.fuse = new Fuse(this.conteudoBusca, {
      shouldSort: true,
      tokenize: true,
      findAllMatches: true,
      threshold: 0.3,
      location: 0,
      distance: 0,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: [
        'categoria',
        'titulo',
        'resposta'
      ]
    })
  },

  methods: {
    limparBusca: function () {
      this.termoPesquisado = ''
      this.resultadoBusca = null
    },

    buscarPerguntasRespostas: function () {
      if (this.pesquisa) {
        this.termoPesquisado = this.pesquisa
        this.resultadoBusca = this.fuse.search(this.termoPesquisado)
      }
    }
  }
}
</script>

<style scoped>

</style>
